/**
 * @fileoverview Country select and profile toggle for the second company address.
 */

import React from "react";
import { IconButton } from "@mui/material";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import styles from "./Location.module.css";
import Select from "react-select";
import { logger } from "../../../utils/logger.js";
import { selectStyles } from "../../../utils/common";
import { getSafeSelectedOption } from "./locationSelectUtils";
import {
  CURSOR_NOT_ALLOWED,
  SHOW_IN_PROFILE_KEY,
  TOGGLE_COLOR_ACTIVE,
  TOGGLE_COLOR_INACTIVE,
} from "./locationConstants";

const SecondAddressCountrySelect = ({ model, t }) => {
  const {
    handleInputChange, handleToggleChange,
    isAddressReadOnly, secondAddressCountryRef,
    secondAddressCountries, segundoDomicilioPais,
    setSegundoDomicilioPais, segundoDomicilioMostrarPais,
    setSegundoDomicilioMostrarPais,
  } = model;

  return (
    <div className={styles.inputGroup}>
      <label className={styles.inputLabel}>
        {t("components.location.countryLabel")}
      </label>
      <Select
        ref={secondAddressCountryRef}
        isSearchable={true}
        isDisabled={true}
        value={getSafeSelectedOption(
          secondAddressCountries,
          segundoDomicilioPais,
        )}
        onChange={(selectedOption) => {
          logger.info("+++ Second Country selectedOption:", {
            data: selectedOption,
          });
          if (!selectedOption) {
            return;
          }
          setSegundoDomicilioPais(selectedOption._id);
          handleInputChange("domicilio2Pais", selectedOption._id);
        }}
        options={secondAddressCountries}
        placeholder={t("components.location.countryPlaceholder")}
        styles={selectStyles}
        className="select__control"
        getOptionValue={(option) => option._id}
        formatOptionLabel={(option) => <span>{option.nombre}</span>}
      />
      <div className={styles.showInProfileContainer}>
        <span className={styles.showInProfileText}>
          {t(SHOW_IN_PROFILE_KEY)}
        </span>
        <IconButton
          onClick={() => {
            setSegundoDomicilioMostrarPais(!segundoDomicilioMostrarPais);
            handleToggleChange(
              "domicilio2MostrarPais",
              !segundoDomicilioMostrarPais,
            );
          }}
          size="small"
          disabled={isAddressReadOnly}
          className={styles.toggleButton}
          sx={{
            "&.Mui-disabled": {
              cursor: CURSOR_NOT_ALLOWED,
              pointerEvents: "auto",
            },
            "& .MuiSvgIcon-root": {
              color: segundoDomicilioMostrarPais
                ? TOGGLE_COLOR_ACTIVE
                : TOGGLE_COLOR_INACTIVE,
            },
          }}
        >
          {segundoDomicilioMostrarPais ? (
            <ToggleOnIcon />
          ) : (
            <ToggleOffIcon />
          )}
        </IconButton>
      </div>
    </div>
  );
};

export default SecondAddressCountrySelect;
